export const sectors = [
    'Environmental',
    'Infrastructure',
    'Industrial Products & Services',
    'Shipbuilding',
    'Automotive',
    'Electric & Electronics',
    'Waste Management',
    'Water & Wastewater',
    'Oil & Gas',
    'Pipelines',
    'Consumer Goods',
];

